<template>
  <AdministrationDossier />
</template>

<script>
import AdministrationDossier from "@/components/dossier/AdministrationDossier.vue";

export default {
  name: "AdminDossier",
  components: {
    AdministrationDossier,
  },
  data() {},
};
</script>
